import { render } from "./orderReviews.vue?vue&type=template&id=28442d24&scoped=true"
import script from "./orderReviews.vue?vue&type=script&lang=js"
export * from "./orderReviews.vue?vue&type=script&lang=js"

import "./orderReviews.vue?vue&type=style&index=0&id=28442d24&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28442d24"]])

export default __exports__